import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, Button, HStack } from '@chakra-ui/react';
import { Printer } from 'lucide-react';
import ShiftReportContent from './ShiftReportContent';

/**
 * /print/shift/:id — the shift slip as a plain page. Opens the print
 * dialog once the report has loaded; the buttons are hidden on paper.
 */
const ShiftReportPrintPage = () => {
  const { id } = useParams();
  const { t } = useTranslation('reports');
  const [ready, setReady] = useState(false);

  const onLoaded = () => {
    setReady(true);
    // Let the table paint before the dialog freezes the page
    setTimeout(() => window.print(), 300);
  };

  return (
    <Box maxW="900px" mx="auto" p={6} bg="white" minH="100vh">
      <style>{`@media print { .no-print { display: none !important; } body { background: #fff; } }`}</style>
      <HStack className="no-print" mb={4} justify="flex-end">
        <Button size="sm" variant="ghost" onClick={() => window.close()}>
          {t('cashCounter.close', 'Close')}
        </Button>
        <Button size="sm" leftIcon={<Printer size={14} />} onClick={() => window.print()} isDisabled={!ready}>
          {t('payments.print', 'Print')}
        </Button>
      </HStack>
      <ShiftReportContent shiftId={id} onLoaded={onLoaded} />
    </Box>
  );
};

export default ShiftReportPrintPage;
